import React, { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import Instruction from '../Instruction';
import SettingPopup from './SettingPopup.js';
import { useNavigate } from 'react-router-dom';


function AgreementPage(props) {
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const { fontSize } = useSetting();
    const [data, setData] = useState({})
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);
    const [startTime, setStartTime] = useState(new Date().getTime());
    const [timer, setTimer] = useState('10:00');//10 minutes
    const [timeSpentOnQuestion, setTimeSpentOnQuestion] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTimeSpentOnQuestion(prev => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        function updateTimer() {
            const now = new Date().getTime();
            const elapsed = now - startTime;
            const remaining = Math.max(0, 60 * 1000 - elapsed); // 1 minutes in milliseconds
            const minutes = Math.floor(remaining / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            setTimer(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }

        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [startTime]);

    const navigate = useNavigate();



    const isAllQuestionCompleted = () => {
        let isCompleted = true;
        if(data.isAgreed === undefined) {
            isCompleted = false;
        }
        if(data.name === undefined || data.name === '') {
            isCompleted = false;
        }


        return isCompleted;
    }
    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px]'>
                    <div className='flex items-center justify-center'>
                        <div className='text-white bg-[#003A57] py-[8px] px-[24px] rounded-[4px]' style={{ fontSize: fontSize }}>{timer}</div>
                    </div>
                </div>
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>

                </div>


            </div>

            <div className='flex flex-col w-full justify-center items-center  mt-[16px]'>
                <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to left, #55A8E0, #1C7595, #3B77A4)' }}>
                    {props.data?.name}
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: props.data?.subtitle }} />
                </div>
            </div>



            <div className='w-full flex flex-col items-center flex-1 overflow-auto noto-san-hk bg-[#F8FAFB]'>
                <div className='w-full flex flex-col items-start max-w-[1200px] p-[64px]'>
                    <b>參與研究知情同意書</b><br />
                    <br />
                    研究項目： 「多元素養中文閱讀能力提升」研究計劃<br />
                    <br />
                    我們是香港大學教育學院鍾竹梅教授及其研究團隊，希望了解同學的網上閱讀過程，並改善數位閱讀學習。請先閱讀以下資料，再決定是否參與。<br />
                    你將在平台上完成線上中文閱讀練習活動、測試及相關問卷。系統亦可能記錄與任務有關的作答及基本操作資料，以了解你的閱讀過程。<br />
                    參與完全自願。你可以不參加，或隨時退出，不會受到懲罰，也不會影響你的成績、校內評估或與學校／老師的關係。不參與或退出後，你仍可照常參與學校安排的日常學習活動。<br />
                    資料只作研究用途，並會保密。移除身份資料後的研究數據可能用於日後研究及學術發表，但不會公開可識別你身份的個人資料。<br />
                    如想了解研究參與者的權益，可聯絡香港大學研究操守委員會：3917-5267。<br />
                    <br />
                    倫理審批編號：EA250817；HSEARS20261014012<br />
                    <br />
                    香港大學教育學院<br />
                    鍾竹梅教授研究團隊<br />
                    <br />
                    姓名：
                    <input type="text" placeholder="請輸入" className='w-[200px] h-[50px]' onChange={
                        (e)=>{ 
                            let data_ = { ...data }
                            data_.name = e.target.value
                            setData(data_)
                        }
                    } style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '4px 8px', margin: '4px 0' }} />
                    <br />請選擇一項：<br /><br />
                    <div className='flex flex-row gap-[8px]'>
                        <input type="checkbox" checked={data?.isAgreed === true} onChange={(e) => {
                            let data_ = { ...data }
                            data_.isAgreed = e.target.checked
                            setData(data_)
                        }} /> 我已閱讀並明白以上資料，並自願參與本研究。
                    </div>
                    <div className='flex flex-row gap-[8px]'>
                        <input type="checkbox" checked={data?.isAgreed === false} onChange={(e) =>{
                            let data_ = { ...data }
                            data_.isAgreed = !e.target.checked
                            setData(data_)
                        }} /> 我不同意參與本研究。
                    </div>
                    <br />
                    日期：{new Date().toLocaleDateString()}

                </div>

            </div>
            <div className='flex flex-row justify-center bg-[#F8FAFB] py-[16px]'>
                <button onClick={() => {
                    if (!isAllQuestionCompleted()) {
                        alert('請完成所有問題後再提交。')
                        return
                    }

                    let data_ = { ...data }
                    data_.timeSpent = timeSpentOnQuestion;
                    setData(data_);
                    setShowConfirmPopup(true)

                }} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                        提交
                    </div>
                </button>
            </div>
            {showConfirmPopup && <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-50 noto-san-hk font-bold' style={{ backdropFilter: 'blur(18px)' }}>
                <div className='bg-white p-[24px] rounded-[8px] flex flex-col items-center gap-[16px]' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundImage: 'url(/secondary/bg7.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='text-[#6E0526] font-bold mb-[16px]'>小提示</div>
                    <div className='mb-[16px] text-center'>提交後將不能返回修改本部分答案，<br />是否繼續？</div>
                    <div className='flex flex-row gap-[16px]'>
                        <button className='px-[16px] py-[8px] text-black rounded-[4px] min-w-[200px] text-center rounded-full' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #FFFFFF)' }} onClick={() => setShowConfirmPopup(false)}>返回檢查</button>
                        <button className='px-[16px] py-[8px] bg-[#007A83] text-white rounded-[4px] min-w-[200px] text-center rounded-full' onClick={() => {
                            props.onSubmit(data)
                        }}>確認</button>
                    </div>
                </div>
            </div>}
            {isSettingMenuVisible && (
                <SettingPopup onClose={() => { navigate('/platform2/research-practices') }} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}

        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(AgreementPage)
